(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kalohas-brand-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kalohas-brand-film')) {
  customElements.define('kalohas-brand-film', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button || this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      video.controls = false;
      button.hidden = false;
      const update = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
      video.addEventListener('play', update, {signal});
      video.addEventListener('pause', update, {signal});
      button.addEventListener('click', () => { if (video.paused) video.play().catch(update); else video.pause(); }, {signal});
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!motion.matches) video.play().catch(update);
      motion.addEventListener('change', event => { if (event.matches) video.pause(); }, {signal});
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
